"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEvents = void 0;
class IEvents {
}
exports.IEvents = IEvents;
//# sourceMappingURL=misc.js.map